import { render, staticRenderFns } from "./BaseReport.vue?vue&type=template&id=86565df6"
import script from "./BaseReport.vue?vue&type=script&lang=ts"
export * from "./BaseReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports